import { Icon } from '@equinor/eds-core-react'
import {
    accessible,
    account_circle as accountCircle,
    add,
    add_circle_outlined,
    arrow_drop_down,
    arrow_drop_up,
    battery,
    check,
    chevron_down,
    chevron_up,
    clear,
    close,
    copy,
    delete_to_trash as deleteToTrash,
    done,
    edit,
    error_filled,
    error_filled as errorFilled,
    error_outlined as errorOutlined,
    external_link,
    filter_alt,
    fullscreen,
    go_to,
    grid_on,
    help_outline as helpOutline,
    info_circle as infoCircle,
    list,
    lock,
    log_out as logOut,
    menu,
    mood_very_sad as moodVerySad,
    more_vertical as moreVertical,
    notifications,
    open_in_browser as openInBrowser,
    play,
    refresh,
    remove_outlined,
    report_bug as reportError,
    save,
    send,
    settings,
    sort,
    stop,
    swap_vertical,
    tune,
    thumbs_up_down as thumbsUpDown,
    unfold_less as unfoldLess,
    unfold_more as unfoldMore,
    view_list,
    visibility,
    visibility_off,
    wifi,
    close_circle_outlined,
} from '@equinor/eds-icons'

const icons = {
    accessible,
    accountCircle,
    add,
    add_circle_outlined,
    arrow_drop_down,
    arrow_drop_up,
    battery,
    check,
    chevron_down,
    chevron_up,
    clear,
    close,
    copy,
    deleteToTrash,
    done,
    edit,
    errorFilled,
    errorOutlined,
    error_filled,
    external_link,
    filter_alt,
    fullscreen,
    go_to,
    grid_on,
    helpOutline,
    infoCircle,
    list,
    lock,
    logOut,
    menu,
    moodVerySad,
    moreVertical,
    notifications,
    openInBrowser,
    play,
    refresh,
    remove_outlined,
    reportError,
    save,
    send,
    settings,
    sort,
    stop,
    swap_vertical,
    tune,
    thumbsUpDown,
    unfoldLess,
    unfoldMore,
    view_list,
    visibility,
    visibility_off,
    wifi,
    close_circle_outlined,
}

Icon.add(icons)

export default Icon
